/**
 * @generated SignedSource<<322508700e8092d392b5e2b4959309e1>>
 * @relayHash 5073648d90541e3e94e51a23868f3883
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 71d3230b0bf584023f0d44d178d794c2edd97886491a64288c9d39d43f58b154

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HomeAssignedListQuery$variables = {
  first?: number | null;
  jiraIssueQuery: string;
  pullRequestQuery: string;
  queryContext: string;
  townsquareQuery: string;
};
export type HomeAssignedListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HomeAssignedList">;
};
export type HomeAssignedListQuery = {
  response: HomeAssignedListQuery$data;
  variables: HomeAssignedListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraIssueQuery"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pullRequestQuery"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "townsquareQuery"
},
v5 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v6 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "url"
},
v9 = {
  "kind": "ScalarField",
  "name": "value"
},
v10 = [
  (v9/*: any*/)
],
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = [
  {
    "kind": "ScalarField",
    "name": "creationDate"
  },
  {
    "kind": "ScalarField",
    "name": "editDate"
  },
  (v12/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "name": "name"
},
v15 = {
  "kind": "ScalarField",
  "name": "iconData"
},
v16 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v17 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v14/*: any*/),
    (v16/*: any*/),
    (v12/*: any*/)
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v19 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v20 = {
  "kind": "ScalarField",
  "name": "picture"
},
v21 = [
  (v12/*: any*/)
],
v22 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "AppUser"
},
v23 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "CustomerUser"
},
v24 = [
  {
    "concreteType": "ThirdPartyUser",
    "kind": "LinkedField",
    "name": "thirdPartyUser",
    "plural": false,
    "selections": [
      (v14/*: any*/),
      (v20/*: any*/),
      (v12/*: any*/)
    ]
  },
  {
    "args": (v11/*: any*/),
    "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
    "kind": "LinkedField",
    "name": "linkedUsers",
    "plural": false,
    "selections": [
      {
        "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v14/*: any*/),
                  (v20/*: any*/),
                  (v19/*: any*/),
                  (v16/*: any*/),
                  (v12/*: any*/)
                ],
                "type": "AtlassianAccountUser"
              },
              (v22/*: any*/),
              (v23/*: any*/)
            ]
          },
          (v12/*: any*/)
        ]
      }
    ],
    "storageKey": "linkedUsers(first:1)"
  }
],
v25 = [
  {
    "concreteType": "GraphStoreCypherQueryV2Edge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "GraphStoreCypherQueryV2Node",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphStoreCypherQueryV2Column",
            "kind": "LinkedField",
            "name": "columns",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "value",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              {
                                "alias": "goalState",
                                "concreteType": "TownsquareGoalState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": (v10/*: any*/)
                              },
                              {
                                "alias": "goalCreationDate",
                                "kind": "ScalarField",
                                "name": "creationDate"
                              },
                              {
                                "alias": "goalUpdates",
                                "args": (v11/*: any*/),
                                "concreteType": "TownsquareGoalUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v13/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:1)"
                              },
                              (v12/*: any*/),
                              (v14/*: any*/),
                              {
                                "alias": "goalStatus",
                                "concreteType": "TownsquareStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "score"
                                  }
                                ]
                              },
                              (v15/*: any*/),
                              (v17/*: any*/)
                            ],
                            "type": "TownsquareGoal"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              {
                                "alias": "projectState",
                                "concreteType": "TownsquareProjectState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": (v10/*: any*/)
                              },
                              {
                                "alias": "projectCreationDate",
                                "kind": "ScalarField",
                                "name": "creationDate"
                              },
                              {
                                "alias": "projectUpdates",
                                "args": (v11/*: any*/),
                                "concreteType": "TownsquareProjectUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareProjectUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareProjectUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v13/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:1)"
                              },
                              (v12/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v17/*: any*/)
                            ],
                            "type": "TownsquareProject"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              {
                                "concreteType": "JiraStatusField",
                                "kind": "LinkedField",
                                "name": "statusField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "mercuryName"
                                          },
                                          (v12/*: any*/)
                                        ]
                                      },
                                      (v12/*: any*/),
                                      (v14/*: any*/)
                                    ]
                                  },
                                  (v12/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraDateTimePickerField",
                                "kind": "LinkedField",
                                "name": "updatedField",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "dateTime"
                                  },
                                  (v12/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v19/*: any*/),
                                  (v12/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "summary"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "key"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "dueDate"
                              },
                              (v12/*: any*/),
                              {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      {
                                        "concreteType": "JiraAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "small"
                                          }
                                        ]
                                      },
                                      (v12/*: any*/)
                                    ]
                                  },
                                  (v12/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraProjectField",
                                "kind": "LinkedField",
                                "name": "projectField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "project",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v18/*: any*/),
                                      (v12/*: any*/)
                                    ]
                                  },
                                  (v12/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "status"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "lastUpdate"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "thirdPartyId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": (v24/*: any*/)
                              },
                              {
                                "concreteType": "ExternalReviewer",
                                "kind": "LinkedField",
                                "name": "reviewers",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "approvalStatus"
                                  },
                                  {
                                    "concreteType": "ExternalUser",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": (v24/*: any*/)
                                  }
                                ]
                              },
                              {
                                "concreteType": "ExternalProvider",
                                "kind": "LinkedField",
                                "name": "provider",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/)
                                ]
                              }
                            ],
                            "type": "ExternalPullRequest"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "Node",
                            "abstractKey": "__isNode"
                          },
                          (v22/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "AtlassianAccountUser"
                          },
                          (v23/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsFeatureFlag"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsOperationsComponentDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsOperationsIncidentDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsProjectDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsPullRequestDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsRepository"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "DevOpsSecurityVulnerabilityDetails"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "JiraAutodevJob"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "JiraConfluenceRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "JiraCustomRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "JiraIssueRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "JiraWebRemoteIssueLink"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "TeamCustomFieldValue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "TeamType"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v21/*: any*/),
                            "type": "ThirdPartyUser"
                          }
                        ]
                      },
                      (v12/*: any*/)
                    ],
                    "type": "GraphStoreCypherQueryV2AriNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v10/*: any*/),
                    "type": "GraphStoreCypherQueryV2TimestampObject"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HomeAssignedListQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "jiraIssueQuery",
            "variableName": "jiraIssueQuery"
          },
          {
            "kind": "Variable",
            "name": "pullRequestQuery",
            "variableName": "pullRequestQuery"
          },
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "townsquareQuery",
            "variableName": "townsquareQuery"
          }
        ],
        "kind": "FragmentSpread",
        "name": "HomeAssignedList"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeAssignedListQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "alias": "townsquare",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "townsquareQuery"
              },
              (v6/*: any*/)
            ],
            "concreteType": "GraphStoreCypherQueryV2Connection",
            "kind": "LinkedField",
            "name": "cypherQueryV2",
            "plural": false,
            "selections": (v25/*: any*/)
          },
          {
            "alias": "jiraIssue",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "jiraIssueQuery"
              },
              (v6/*: any*/)
            ],
            "concreteType": "GraphStoreCypherQueryV2Connection",
            "kind": "LinkedField",
            "name": "cypherQueryV2",
            "plural": false,
            "selections": (v25/*: any*/)
          },
          {
            "alias": "pullRequest",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "pullRequestQuery"
              },
              (v6/*: any*/)
            ],
            "concreteType": "GraphStoreCypherQueryV2Connection",
            "kind": "LinkedField",
            "name": "cypherQueryV2",
            "plural": false,
            "selections": (v25/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "id": "71d3230b0bf584023f0d44d178d794c2edd97886491a64288c9d39d43f58b154",
    "metadata": {},
    "name": "HomeAssignedListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d7ee250ed9cef5ee2dd8942bbad595a4";

export default node;
